import { Cookies } from "react-cookie";
import {
  BANNER_SEEN_DATE,
  CART,
  CHANGE_PASSWORD_REDIRECT,
  COLOR_MODE,
  LANGUAGE,
  NECESSARY_COOKIES,
  NOTE,
  OPTIONAL_COOKIES,
  PAYMENT_TYPE,
  PRODUCTS_SCROLL_DATA
} from "../constants/global";

const cookies = new Cookies();

const necessaryItems = [
  CART,
  PAYMENT_TYPE,
  NOTE,
  LANGUAGE,
  NECESSARY_COOKIES,
  OPTIONAL_COOKIES,
  CHANGE_PASSWORD_REDIRECT,
  BANNER_SEEN_DATE,
  PRODUCTS_SCROLL_DATA
]; // Neccessary items, that will be stored regardless of the cookie settings
const functionalItems = [COLOR_MODE]; // Functional items, that will be stored if the user allows functional cookies

const sessionStoreItems = [CHANGE_PASSWORD_REDIRECT, BANNER_SEEN_DATE, PRODUCTS_SCROLL_DATA];
const localStoreItems = [CART, PAYMENT_TYPE, NOTE, LANGUAGE, COLOR_MODE];
const cookieItems = [NECESSARY_COOKIES, OPTIONAL_COOKIES];

export const getItem = (name: string) => {
  const item = localStoreItems.includes(name)
    ? localStorage.getItem(name)
    : sessionStoreItems.includes(name)
    ? sessionStorage.getItem(name)
    : cookieItems.includes(name)
    ? cookies.get(name)
    : null;

  if (!item) {
    return null;
  }

  try {
    const parsed = JSON.parse(item);
    return parsed;
  } catch (e) {
    return item;
  }
};
export const setItem = (name: string, value: unknown) => {
  if (value === null || value === undefined) {
    return removeItem(name);
  }

  if (!necessaryItems.includes(name) && !functionalItems.includes(name)) {
    return console.error(`Item ${name} is not defined as necessary or functional.`);
  }

  const valueStringified = typeof value === "string" ? value : JSON.stringify(value);

  if (necessaryItems.includes(name) || functionalItemsEnabled) {
    if (localStoreItems.includes(name)) {
      return localStorage.setItem(name, valueStringified);
    }

    if (sessionStoreItems.includes(name)) {
      return sessionStorage.setItem(name, valueStringified);
    }

    if (cookieItems.includes(name)) {
      return cookies.set(name, valueStringified, {
        sameSite: "lax"
      });
    }

    return console.error(`Item ${name} is not defined as cookie or session storage item.`);
  }
};

export const removeItem = (name: string) => {
  if (localStoreItems.includes(name)) {
    return localStorage.removeItem(name);
  }

  if (sessionStoreItems.includes(name)) {
    return sessionStorage.removeItem(name);
  }

  if (cookieItems.includes(name)) {
    return cookies.remove(name);
  }

  return console.error(`Item ${name} is not defined as cookie or session storage item.`);
};

export const removeFunctionalItems = () => functionalItems.forEach((item) => removeItem(item));

const functionalItemsEnabled = getItem(OPTIONAL_COOKIES) === true;
